import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=2e448d97&scoped=true"
import script from "./Nosotros.vue?vue&type=script&lang=js"
export * from "./Nosotros.vue?vue&type=script&lang=js"
import style0 from "./Nosotros.vue?vue&type=style&index=0&id=2e448d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e448d97",
  null
  
)

export default component.exports